import { makeStyles } from '@material-ui/core'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles(() => ({
  title: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '24px',
    color: themesConfig.default.colors['neutrals-600'],
    marginTop: 12,
    textAlign: 'center',
  },
  dedescription: {
    fontSize: 14,
    lineHeight: '20px',
    color: themesConfig.default.colors['neutrals-600'],
    marginTop: 12,
    textAlign: 'center',
  },
  progressWrapp: {
    position: 'relative',
    display: 'flex',
  },
  bottom: {
    color: '#F1F6FC',
  },
  top: {
    color: themesConfig.default.colors.secondary,
    position: 'absolute',
    left: 0,
  },
  parcent: {
    fontSize: 20,
    lineHeight: 'normal',
    fontWeight: 700,
    color: themesConfig.default.colors['secondary-200'],
  },
  cancelUploadBtn: {
    marginTop: 50,
    marginBottom: 10,
    fontSize: 14,
    cursor: 'pointer',
    lineHeight: '20px',
    color: themesConfig.default.colors['red-600'],
  },
}))
